module.exports = __webpack_public_path__ + "static/img/17.238e626.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/17.png
// module id = zfce
// module chunks = 0